export default Object.freeze({
  CENTROBILL: 'merchant_centrobill',
  COMMERCE: 'merchant_commerce',
  FREE_KASSA: 'merchant_free-kassa',
  ACCENTPAY: 'merchant_accentpay',
  STRIPE: 'merchant_stripe',
})
